import Header from "@/components/header/Header.vue";
import Footer from "@/components/footer/Footer.vue";
import BookCard from "@/components/book-card/BookCard.vue";
import { useToast } from 'vue-toastification';
import axios from '@/config/axios';
const toast = useToast();

export default {
  name: 'SmartRecommendation',
  components: {
    Header,
    Footer,
    BookCard
  },
  data() {
    return {
      isLoading: false,
      isGenresLoading: false,
      prefMood: 'none',
      prefBookType: 'none',
      prefGenres: [],
      prefGoal: 'none',
      prefFreeText: '',
      searchGenreQuery: '',
      suggestedBooks: [],
      selectedBookForModal: null,
      moodOptions: [
        { value: 'none', emoji: '🌀', label: 'Tùy ý, Ngẫu nhiên', description: 'Gợi ý mọi thể loại sách đa dạng cho bạn' },
        { value: 'relaxed', emoji: '🌿', label: 'Thư thái, nhẹ nhàng', description: 'Đọc để thả lỏng tâm trí sau ngày làm việc' },
        { value: 'motivated', emoji: '🔥', label: 'Cần động lực, cảm hứng', description: 'Tìm năng lượng tích cực, bài học cuộc sống' },
        { value: 'curious', emoji: '🔭', label: 'Tò mò, khám phá', description: 'Khám phá tri thức mới, phiêu lưu kỳ bí' },
        { value: 'stressed', emoji: '😄', label: 'Căng thẳng, muốn giải tỏa', description: 'Đọc truyện cười, hài hước, giải trí nhẹ' }
      ],
      bookTypeOptions: [
        { value: 'none', emoji: '📚', label: 'Phong cách bất kỳ', description: 'Không giới hạn hình thức hay độ dài của sách' },
        { value: 'bestsellers', emoji: '🏆', label: 'Sách bán chạy & Thịnh hành', description: 'Những cuốn sách được đọc nhiều nhất gần đây' },
        { value: 'classics', emoji: '⏳', label: 'Tác phẩm kinh điển', description: 'Những giá trị vượt thời gian, trường tồn lâu năm' },
        { value: 'short', emoji: '⚡', label: 'Sách ngắn / Đọc nhanh', description: 'Dưới 200 trang, dễ dàng hoàn thành trong ngày' },
        { value: 'deep', emoji: '🔬', label: 'Sách chuyên sâu / Nghiên cứu', description: 'Nội dung dày dặn, đòi hỏi tập trung suy ngẫm' }
      ],
      genreOptions: [],
      goalOptions: [
        { value: 'none', emoji: '🎲', label: 'Đọc tự do, ngẫu hứng', description: 'Không gò bó mục tiêu, đọc bất cứ khi nào thấy thích' },
        { value: 'soul', emoji: '🌸', label: 'Nuôi dưỡng tâm hồn', description: 'Tìm sự bình yên, thư giãn qua các câu chuyện đẹp' },
        { value: 'career', emoji: '🚀', label: 'Nâng cao kiến thức', description: 'Phát triển kỹ năng nghề nghiệp, mở rộng sự nghiệp' },
        { value: 'entertainment', emoji: '🎭', label: 'Giải trí & Thư giãn', description: 'Truyện ly kỳ, hồi hộp, giết thời gian' },
        { value: 'habit', emoji: '📅', label: 'Rèn thói quen đọc sách', description: 'Duy trì tần suất đọc đều đặn, tích lũy kiến thức' }
      ]
    };
  },
  computed: {
    filteredGenreOptions() {
      let list = [...this.genreOptions];
      list = list.filter(opt => !this.prefGenres.includes(opt.value));
      if (this.searchGenreQuery) {
        const query = this.searchGenreQuery.toLowerCase().trim();
        list = list.filter(opt =>
          opt.label.toLowerCase().includes(query)
        );
      }
      return list.sort((a, b) => {
        return a.label.localeCompare(b.label, 'vi', { sensitivity: 'base' });
      });
    },
    selectedGenres() {
      return this.genreOptions.filter(opt => this.prefGenres.includes(opt.value));
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'BookDetail') {
        const saved = sessionStorage.getItem('smart_rec_state');
        if (saved) {
          try {
            const data = JSON.parse(saved);
            vm.prefFreeText = data.prefFreeText || '';
            vm.prefGenres = data.prefGenres || [];
            vm.prefMood = data.prefMood || 'none';
            vm.prefBookType = data.prefBookType || 'none';
            vm.prefGoal = data.prefGoal || 'none';
            vm.suggestedBooks = data.suggestedBooks || [];
          } catch (e) {
            console.error(e);
          }
        }
      } else {
        sessionStorage.removeItem('smart_rec_state');
      }
    });
  },
  mounted() {
    this.fetchGenres();
  },
  methods: {
    getLabelFromValue(value, optionsArray) {
      if (!value || value === 'none') return '';
      const opt = optionsArray.find(o => o.value === value);
      return opt ? opt.label : '';
    },
    fetchGenres() {
      this.isGenresLoading = true;
      // Icon map: match by keyword in category name
      const iconMap = [
        { keywords: ['văn học', 'tiểu thuyết', 'truyện'], icon: 'fa-solid fa-feather' },
        { keywords: ['kỹ năng', 'phát triển', 'self'], icon: 'fa-solid fa-graduation-cap' },
        { keywords: ['khoa học', 'công nghệ', 'tech'], icon: 'fa-solid fa-atom' },
        { keywords: ['lịch sử', 'triết', 'chính trị'], icon: 'fa-solid fa-landmark' },
        { keywords: ['tâm lý', 'sức khỏe', 'tâm linh'], icon: 'fa-solid fa-brain' },
        { keywords: ['tranh', 'nghệ thuật', 'manga', 'comic'], icon: 'fa-solid fa-palette' },
        { keywords: ['kinh tế', 'tài chính', 'kinh doanh'], icon: 'fa-solid fa-chart-line' },
        { keywords: ['thiếu nhi', 'trẻ em'], icon: 'fa-solid fa-child' },
        { keywords: ['phiêu lưu', 'viễn tưởng', 'fantasy'], icon: 'fa-solid fa-dragon' },
        { keywords: ['nấu ăn', 'ẩm thực'], icon: 'fa-solid fa-utensils' },
      ];
      function pickIcon(name) {
        if (!name) return 'fa-solid fa-book';
        const lower = name.toLowerCase();
        for (const entry of iconMap) {
          if (entry.keywords.some(k => lower.includes(k))) return entry.icon;
        }
        return 'fa-solid fa-book';
      }
      axios.get('category/v1/get-all', { _skip403Redirect: true })
        .then(response => {
          const data = response.data;
          if (data.status === '200' && data.result) {
            const list = Array.isArray(data.result) ? data.result : (data.result.content || []);
            this.genreOptions = list.map(cat => ({
              value: cat.name || cat.title || cat.categoryName || '',
              label: cat.name || cat.title || cat.categoryName || '',
              icon: pickIcon(cat.name || cat.title || '')
            }));
          } else {
            this.loadStaticFallbackGenres();
          }
        })
        .catch(err => {
          console.error('Failed to load categories from API:', err);
          this.loadStaticFallbackGenres();
        })
        .finally(() => {
          this.isGenresLoading = false;
        });
    },
    loadStaticFallbackGenres() {
      const fallbackList = [
        { name: "Văn học & Tiểu thuyết" },
        { name: "Kỹ năng & Phát triển" },
        { name: "Khoa học & Công nghệ" },
        { name: "Lịch sử & Triết học" },
        { name: "Tâm lý học & Sức khỏe" },
        { name: "Truyện tranh & Nghệ thuật" },
        { name: "Kinh tế & Kinh doanh" }
      ];
      const iconMap = [
        { keywords: ['văn học', 'tiểu thuyết', 'truyện'], icon: 'fa-solid fa-feather' },
        { keywords: ['kỹ năng', 'phát triển', 'self'], icon: 'fa-solid fa-graduation-cap' },
        { keywords: ['khoa học', 'công nghệ', 'tech'], icon: 'fa-solid fa-atom' },
        { keywords: ['lịch sử', 'triết', 'chính trị'], icon: 'fa-solid fa-landmark' },
        { keywords: ['tâm lý', 'sức khỏe', 'tâm linh'], icon: 'fa-solid fa-brain' },
        { keywords: ['tranh', 'nghệ thuật', 'manga', 'comic'], icon: 'fa-solid fa-palette' },
        { keywords: ['kinh tế', 'tài chính', 'kinh doanh'], icon: 'fa-solid fa-chart-line' },
      ];
      function pickIcon(name) {
        if (!name) return 'fa-solid fa-book';
        const lower = name.toLowerCase();
        for (const entry of iconMap) {
          if (entry.keywords.some(k => lower.includes(k))) return entry.icon;
        }
        return 'fa-solid fa-book';
      }
      this.genreOptions = fallbackList.map(cat => ({
        value: cat.name,
        label: cat.name,
        icon: pickIcon(cat.name)
      }));
    },
    handleSuggest() {
      // Validate
      if (!this.prefFreeText.trim() && this.prefGenres.length === 0 && this.prefMood === 'none' && this.prefBookType === 'none' && this.prefGoal === 'none') {
        toast.warning('Vui lòng chọn ít nhất 1 tiêu chí hoặc nhập suy nghĩ của bạn để AI có thể gợi ý nhé!');
        return;
      }
      
      this.isLoading = true;
      this.suggestedBooks = [];
      
      const payload = {
        description: this.prefFreeText.trim(),
        categories: this.prefGenres,
        mood: this.getLabelFromValue(this.prefMood, this.moodOptions),
        style: this.getLabelFromValue(this.prefBookType, this.bookTypeOptions),
        target: this.getLabelFromValue(this.prefGoal, this.goalOptions)
      };

      axios.post('book/v1/smart-suggest', payload)
        .then(res => {
          if (res.data.status === '200' && res.data.result) {
            const resultBooks = res.data.result;
            this.suggestedBooks = resultBooks.map(book => ({
              ...book,
              cover: book.cover && !(book.cover.startsWith('data:') || book.cover.startsWith('http'))
                ? 'data:image/png;base64,' + book.cover
                : book.cover
            }));
            if (this.suggestedBooks.length === 0) {
              toast.info('Không tìm thấy sách phù hợp, vui lòng thử lại với tiêu chí khác.');
            }
          } else {
            toast.error(res.data.message || 'Có lỗi xảy ra khi lấy gợi ý!');
          }
        })
        .catch(err => {
          console.error(err);
          toast.error('Có lỗi xảy ra khi gọi AI!');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleCardClick(bookId) {
      sessionStorage.setItem('smart_rec_state', JSON.stringify({
        prefFreeText: this.prefFreeText,
        prefGenres: this.prefGenres,
        prefMood: this.prefMood,
        prefBookType: this.prefBookType,
        prefGoal: this.prefGoal,
        suggestedBooks: this.suggestedBooks
      }));
      this.$router.push('/book/' + bookId);
    },
    openReasonModal(book) {
      this.selectedBookForModal = book;
    },
    closeReasonModal() {
      this.selectedBookForModal = null;
    }
  }
};
